<div class="success-container">
  <div class="success-card">
    <div class="checkmark">✓</div>
    <h1>Payment Successfully Received</h1>
    <p>Enjoy your stay!</p>
  </div>
</div>